import React, {Component} from 'react';
import PropTypes from 'prop-types';
import css from './CwToolbar.scss';

export default class CwToolbar extends Component {
  render() {
    return (
      <div data-cwid={this.props.cwId} className={css.toolbar}>
        <div className={css.overflowButtons}>
          {this.props.overflowButtons}
        </div>
        {this.props.rightButtons ?
          <div className={css.rightButtons}>
            {this.props.rightButtons}
          </div>
          : null}
      </div>
    );
  }
}

CwToolbar.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  overflowButtons: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  rightButtons: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
};


// WEBPACK FOOTER //
// ./src/components/cwtoolbar/CwToolbar.jsx